import React from 'react';
import { Link } from 'react-router-dom';

class Photo extends React.Component {

  render() {
    const {post, index, comments} = this.props;
    const detailUrl = `/photos/view/${post.id}`;

    return (
      <figure>
        <Link to={detailUrl}>
          {post.url}
        </Link>
        <figcaption>
          <p>{post.caption}</p>
          <div>
            <button onClick={this.props.increment.bind(null, index)}>&hearts; {post.likes}</button>
            <Link to={detailUrl}>{comments[post.id] ? comments[post.id].length : 0}</Link>
          </div>
        </figcaption>
      </figure>
    )
  }
}

export default Photo;


// WEBPACK FOOTER //
// ./src/components/photogram/photo.js